var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"x-html-viewer"},[_c('div',{domProps:{"innerHTML":_vm._s(_vm.content)},on:{"click":_vm.onClick}}),_c('image-viewer',{ref:"imageViewer"})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }